<div class="container-fluid">
  <div class="invoiceWrapper">
    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-lg-10">
        <div class="card">
          <div class="card-body">
            <div class="headerWrapper">
              <h4> Implant Types</h4>
              <div class="buttonWrapper">
                <button *ngIf="addPermission === true" (click)="openDialog()" class="btn btn-success btn-sm" mat-raised-button>
                  <i aria-hidden="true" class="fa fa-plus"></i>ADD NEW
                </button>
                <button *ngIf="editPermission === true" (click)="editDialog(selectedIndex)" class="btn btn-warning btn-sm">
                  <i aria-hidden="true" class="fa fa-pencil-square-o"></i>EDIT
                </button>
                <button *ngIf="deletePermission === true" (click)="deleteDialog(selectedIndex)" class="btn btn-danger btn-sm">
                  <i aria-hidden="true" class="fa fa-trash"></i>DELETE
                </button>
              </div>
            </div>
            <div class="customModal">
            </div>
            <table class="table table-bordered" *ngIf="viewPermission === true">
              <thead>
              <tr>
                <th scope="col">Body Part</th>
                <th scope="col">Implant Name</th>
              </tr>
              </thead>
              <tbody>
              <tr (click)="selectRow(i)"
                  (dblclick)="editDialog(selectedIndex)"
                  *ngFor="let in of implants | slice: 0:10| paginate: { id: 'stockPageId', itemsPerPage: per_page, currentPage: current_page, totalItems: total_count}; let i = index " [ngClass]="{'sel': i === selectedIndex }"
                  rowspan="" style="height: 36px;">
                <td>{{in.body_part_name}}</td>
                <td>{{in.name}}</td>
              </tr>
              </tbody>
            </table>
            <div class="footerWrapper row">
              <div class="col-lg-7 col-md-12 col-sm-12">
                <div class="input-group">
                  <select (change)="getSearchValue()" [(ngModel)]="searchBy" class="form-control border"
                          data-show-content="true" name="searchBy">
                    <option name="implantNoName" value="0"> Search by Implant Type</option>
                    <option name="bodyNoName" value="1"> Search by Body Part</option>
                  </select>
                  <input [(ngModel)]="searchTxt" [placeholder]="placeHolder" class="form-control" name="searchTxt" placeholder="Search" type="text">
                    <span (click)="doSearch()" class="input-group-text">
                        <i aria-hidden="true" class="fa fa-search"></i>
                    </span>
                    <span (click)="doRefresh()" class="input-group-text">
                        <i aria-hidden="true" class="fa fa-refresh"></i>
                    </span>
                </div>
              </div>
              <div class="col-lg-5 col-md-12 col-sm-12">
                <app-common-page (pageChange)="doPaginate($event)" [id]="stockPageId">
                </app-common-page>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-1"></div>
    </div>
  </div>
</div>
